<template>
  <div>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="mr-1 per-page-selector d-inline-block ml-50"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
        >
          <b-button v-b-modal.request-modal variant="primary">
            Export PDF
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-table
      class="border"
      responsive
      striped
      :items="compare"
      :fields="compareFields"
    />
    <div class="px-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BFormInput,
  BPagination,
  VBModal,
  BForm,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  props: ['compareItem'],
  components: {
    BTable,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    VSelect,
    BFormInput,
    BPagination,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
  },

  directives: {
    Ripple,
    VBModal,
  },

  data() {
    return {
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      compare: [],
      compareFields: [
        { key: 'param', label: 'Parameter', sortable: false }
      ],
      searchWord: '',
      products: [],
      form: { isLoading: false },
      selectedProducts: [],
      param: null
    }
  },

  watch: {
    perPage() {
      this.fetchCompare()
    },
    currentPage() {
      this.fetchCompare()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
    compareItem(newVal) {
      console.log(newVal)
      this.test()
    }
  },

  mounted() {

  },

  methods: {
    test(){
      alert("add")
    },
    fetchCompare() {
      
    },

    searchByTitle: debounce(function() {
      this.fetchcompare()
    }, 200),

    changePage(page) {
      this.currentPage = page
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
